<template>
  <div>
    <!-- پاپ‌آپ تنظیمات لیبل قیمت -->
    <custom-popup
      v-model="internalVisible"
      :cons="{ title: 'ساخت و تولید خودکار لیبل قیمت QR', icon: 'qrcode-plus' }"
      max-width="650px"
      hide-confirm
      @close="onUserDismiss"
    >
      <v-card class="rounded-xl">
        <v-card-text class="pt-4 pb-2">
          <v-alert dense text type="info" class="text-caption mb-4 rounded-lg">
            {{ alertMessage }}
          </v-alert>

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="customSettings.storeName"
                label="نام مجموعه / فروشگاه (اختیاری)"
                placeholder="مثال: فروشگاه کیوآرلند"
                outlined
                dense
                prepend-inner-icon="mdi-storefront-outline"
                clearable
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="customSettings.brandName"
                label="نام برند (اختیاری)"
                placeholder="مثال: ترمینال ادز"
                outlined
                dense
                prepend-inner-icon="mdi-tag-outline"
                clearable
              />
            </v-col>

            <v-col cols="12">
              <v-card outlined class="pa-3 rounded-lg bg-white">
                <div class="text-caption font-weight-bold grey--text text--darken-2 mb-2 d-flex align-center">
                  <v-icon small class="ml-1">mdi-image-filter-hdr</v-icon>
                  تصویر پس‌زمینه
                </div>
                <pic-selector
                  :edit-name="false"
                  :field.sync="backgroundImage"
                  default-cat-name="پس‌زمینه"
                  one-pic
                  single
                  :is_digi="false"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider />

        <v-card-actions class="pa-4 bg-grey-lighten-4">
          <v-btn class="btn-delete rounded-lg px-4" @click="onUserDismiss">
            <v-icon>mdi-close</v-icon>
            انصراف
          </v-btn>
          <v-spacer />
          <v-btn
            class="btn-get-code rounded-lg px-6"
            elevation="1"
            :loading="isProcessing"
            @click="startBackgroundProcess"
          >
            <v-icon left>mdi-check-all</v-icon>
            تولید و ثبت کیوآرها
          </v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <!-- المان مخفی کانوَس که زنده می‌ماند تا همه آیتم‌ها کامل ساخته شوند -->
    <div style="position: absolute; left: -9999px; top: -9999px; width: 1px; height: 1px; overflow: hidden; opacity: 0; pointer-events: none;">
      <qr-code-make
        ref="qrCanvas"
        v-model="qrDesign"
        :file.sync="qrSvgDataUrl"
        :link="fullLink"
        @save="qrDesign = $event"
      />
    </div>
  </div>
</template>

<script>
import PicSelector from "../../../components/UploadCenter/picSelector.vue";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import { qrQueue } from "@/services/qrQueue";

export default {
  name: "GeneratePriceLabelModal",
  components: {
    PicSelector,
    QrCodeMake,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
    productGallery: {
      type: Array,
      default: () => [],
    },
    selectedSkus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      internalVisible: true,
      isProcessing: false,
      theme: "priceLabelTheme",
      qrDesign: {},
      qrSvgDataUrl: "",
      createdDomain: null,
      createdId: null,
      currentQrInfo: null,
      domainId: 5,
      backgroundImage: "",
      customSettings: {
        storeName: "",
        brandName: "",
      },
    };
  },
  computed: {
    fullLink() {
      if (!this.createdDomain || !this.createdId) return "";
      return this.createdDomain.replace("/", "") + "/" + this.createdId;
    },
    targetItems() {
      if (!this.product.has_variants) {
        return [
          {
            isSimple: true,
            id: this.product.id,
            sku: this.product.sku,
            title: this.product.title,
            min_price: this.product.default_min_price || this.product.price || this.product.consumer_price,
            max_price: this.product.default_max_price || this.product.production_cost,
            gallery: this.productGallery,
            description: this.product.description,
          },
        ];
      }
      return this.selectedSkus.length > 0 ? this.selectedSkus : (this.product.skus || []);
    },
    alertMessage() {
      if (!this.product.has_variants) {
        return "برای این محصول ساده، ۱ کیوآر لیبل قیمت با مشخصات محصول ساخته خواهد شد.";
      }
      return `تعداد ${this.targetItems.length} لیبل قیمت برای تنوع‌های محصول ساخته خواهد شد.`;
    },
  },
  methods: {
    onUserDismiss() {
      if (this.isProcessing) {
        this.internalVisible = false;
        this.$toast.info("فرآیند در پس‌زمینه ادامه دارد...");
        return;
      }
      this.internalVisible = false;
      this.$emit("input", false);
      this.$emit("close");
    },

    parseNumericPrice(val) {
      if (!val) return 0;
      const normalized = String(val)
        .replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d))
        .replace(/[٠-٩]/g, (d) => "٠١٢٣٤٥٦٧٨٩".indexOf(d))
        .replace(/,/g, "")
        .trim();
      return Number(normalized) || 0;
    },

    extractUrl(img) {
      if (!img) return "";
      if (typeof img === "string") return img;
      return img.url || img.path || img.src || "";
    },

    getMainImageUrl(gallery) {
      if (!gallery) return "";
      let allImages = [];

      if (Array.isArray(gallery)) {
        gallery.forEach((entry) => {
          if (!entry) return;
          if (Array.isArray(entry.images)) {
            entry.images.forEach((img) => img && allImages.push(img));
          } else {
            allImages.push(entry);
          }
        });
      } else if (typeof gallery === "object") {
        allImages.push(gallery);
      }

      if (!allImages.length) return "";

      const main = allImages.find(
        (img) =>
          typeof img === "object" &&
          (img.is_main === true || img.is_main === 1 || img.is_main === "1")
      );
      return this.extractUrl(main || allImages[0]);
    },

    sanitizeSlug(text) {
      if (!text) return "";
      return String(text)
        .trim()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(/[^\w\u0600-\u06FF-]/g, "")
        .replace(/--+/g, "-");
    },

    generateBaseIdentifier(item) {
      const prodPart = this.product.id || this.sanitizeSlug(this.product.sku) || "prod";
      if (item.isSimple) {
        return `${prodPart}-label`;
      }
      const skuPart = item.sku ? this.sanitizeSlug(item.sku) : (item.id || "var");
      return `${prodPart}-${skuPart}`;
    },

    buildCardData({ labelName, profileImg, backgroundImg, consumerPrice, productionPrice, description }) {
      const safeProfile = profileImg || "";
      const safeDesc = description ? String(description).trim() : "";
      const transparentPixel =
        "data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCA==QAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";

      return {
        photo: {
          profile: safeProfile,
          background: backgroundImg ? backgroundImg : transparentPixel,
          headBackground: "",
          gallery: safeProfile ? [{ images: [{ url: safeProfile }] }] : [{ images: [] }],
        },
        order: [
          { name: "price" },
          { name: "bPrice" },
          { name: "cPrice" },
          { name: "discount" },
          { name: "description" },
          { name: "descriptions" },
          { name: "discriptions" },
        ],
        pallete: {
          headColor: "linear-gradient(to top left , #D4AF37FF, #00616479)",
          bodyColor: "linear-gradient(to top left , #D4AF376C, #08597F5A)",
          textColor: "#294377",
          borderColor: "#393939",
        },
        profile: safeProfile,
        label: {
          name: { text: this.customSettings.storeName || "", line: false },
          labelName: { text: labelName || "", line: false },
          brand: { text: this.customSettings.brandName || "", line: false },
          bPrice: { text: consumerPrice || 0, line: false },
          price: { text: null, line: false },
          cPrice: { text: productionPrice || 0, line: false },
          discount: { text: 0, line: false },
          description: { text: safeDesc, line: false },
          descriptions: { text: safeDesc, line: false },
          discriptions: { text: safeDesc, line: false },
        },
        visitName: labelName,
      };
    },

    async stepStore(cardData, visitTitle, baseIdentifier) {
      const maxRetries = 5;
      let attempt = 0;
      let currentIdentifier = baseIdentifier;

      while (attempt <= maxRetries) {
        try {
          const payload = {
            type: "pricelabel",
            qrType: "dynamic",
            title: visitTitle,
            domain_id: this.domainId,
            identifier: currentIdentifier,
            data: JSON.stringify({
              theme: this.theme,
              data: cardData,
            }),
            qr: JSON.stringify(this.qrDesign),
          };

          const { data } = await this.$api.post(`${this.$qrApi}/v1/testQr/store`, payload);
          this.currentQrInfo = data.data;
          this.createdId = data.data.identifier;
          this.createdDomain = data.data?.domain?.name || "qrland.in/";
          return data.data;
        } catch (error) {
          const isValidationError = error?.response?.status === 422;
          const errors = error?.response?.data?.errors;
          const isIdentifierTaken = errors && (errors.identifier || errors.title);

          if (isValidationError && (isIdentifierTaken || attempt < maxRetries)) {
            attempt++;
            const randomCode = Math.random().toString(36).substring(2, 4);
            currentIdentifier = `${baseIdentifier}-${attempt}${randomCode ? "-" + randomCode : ""}`;
            continue;
          }
          throw error;
        }
      }
      throw new Error("امکان ثبت شناسه یکتا پس از چند بار تلاش وجود ندارد.");
    },

    async stepRenderCanvas(link) {
      if (this.$refs.qrCanvas && this.$refs.qrCanvas.appendCanvas) {
        this.$refs.qrCanvas.appendCanvas(link);
      }
      return new Promise((resolve) => setTimeout(resolve, 450));
    },

    async stepUpdate(cardData) {
      const formData = new FormData();
      formData.append("type", "pricelabel");
      formData.append("image", this.qrSvgDataUrl);
      formData.append("qrType", "dynamic");
      formData.append("domain", this.createdDomain);
      formData.append("identifier", this.createdId || "");
      formData.append("qr_id", this.currentQrInfo.qrId || this.currentQrInfo.id);
      formData.append("_method", "PUT");
      formData.append(
        "data",
        JSON.stringify({
          theme: this.theme,
          data: cardData,
        })
      );
      formData.append("qr", JSON.stringify(this.qrDesign));

      const res = await this.$api.post(`${this.$qrApi}/v1/testQr/update`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      return res.data;
    },

    async processSingleItem(item, mainProductImg, bgImg) {
      const isSimple = item.isSimple;
      const combinedTitle = isSimple
        ? this.product.title
        : item.title
        ? `${this.product.title} - ${item.title}`
        : this.product.title;

      const profileImg =
        this.getMainImageUrl(item.gallery) ||
        this.extractUrl(item.image) ||
        this.extractUrl(item.pic) ||
        mainProductImg;

      const itemDescription =
        item.description ||
        this.product.description ||
        this.product.attributes ||
        "";

      const productionPrice = this.parseNumericPrice(item.max_price);
      const consumerPrice = this.parseNumericPrice(item.min_price);

      const cardData = this.buildCardData({
        labelName: combinedTitle,
        profileImg,
        backgroundImg: bgImg,
        consumerPrice,
        productionPrice,
        description: itemDescription,
      });

      const baseIdentifier = this.generateBaseIdentifier(item);

      const storeRes = await this.stepStore(cardData, `لیبل - ${combinedTitle}`, baseIdentifier);
      await this.stepRenderCanvas(storeRes.link);
      await this.stepUpdate(cardData);
    },

    async startBackgroundProcess() {
      const items = this.targetItems;
      if (!items || !items.length) {
        this.$toast.warning("موردی برای ساخت لیبل وجود ندارد.");
        return;
      }

      this.isProcessing = true;
      const pId = String(this.product.id || "batch");
      const pTitle = this.product.title || "محصول";

      // ۱. شروع در صف
      qrQueue.startTask(pId, items.length, pTitle);

      // ۲. پاپ‌آپ بسته می‌شود اما کانوَس برای ساخت کامل در دام می‌ماند
      this.internalVisible = false;
      this.$toast.info("فرآیند ساخت در پس‌زمینه آغاز شد...");

      const mainProductImg = this.getMainImageUrl(this.productGallery);
      const bgImg = this.backgroundImage || "";

      try {
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          const displayTitle = item.title || pTitle;

          qrQueue.updateProgress(pId, i + 1, items.length, displayTitle);
          await this.processSingleItem(item, mainProductImg, bgImg);
        }

        qrQueue.finishTask(pId);
        this.$toast.success(`تمام لیبل‌های QR برای "${pTitle}" با موفقیت ساخته شدند.`);
        this.$emit("saved");
      } catch (err) {
        console.error("QR Generation Error:", err);
        qrQueue.failTask(pId, err);
        const errorMsg =
          err?.response?.data?.message || "خطا در مراحل ساخت کیوآر در پس‌زمینه";
        this.$toast.error(errorMsg);
      } finally {
        this.isProcessing = false;
        // فقط پس از ساخت کامل کل موارد بسته شود
        this.$emit("input", false);
        this.$emit("close");
      }
    },
  },
};
</script>
